import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiDivider = ({ misc }: Pick<Tokens, 'misc'>) =>
  ({
    MuiDivider: {
      styleOverrides: {
        root: {
          borderBottom: misc.borderStyle('components.divider.line'),
        },
        vertical: {
          height: '100%',
          width: spacing(0.125),
          borderRight: misc.borderStyle('components.divider.line'),
          borderBottomWidth: 0,
        },
        withChildren: {
          borderBottomWidth: 0,
        },
      },
    },
  }) satisfies ComponentCreation
